import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedDropDownRHFWithLabel,
	LabelPosition,
	RHookFormDatePicker,
} from "@websential/cosmic-v20";
import React, { useEffect, useState } from "react";

import { Grid } from "@mui/material";


interface ITimeSheetReportHeader {
	payPeriodListItems: any;
	employeeDDLListItems: any;
	// classesDDLList:any,
	setStateRunGetListAPICall: (value: boolean) => void
}
export const TimeSheetReportHeader: React.FC<
	ITimeSheetReportHeader
> = ({
	// classesDDLList,
	payPeriodListItems,
	employeeDDLListItems,
	setStateRunGetListAPICall }) => {


		const currentDate = new Date();
		const firstDayOfCurrentMonth = new Date(
			currentDate.getFullYear(),
			currentDate.getMonth(),
			1
		);
		const lastDayOfCurrentMonth = new Date(
			currentDate.getFullYear(),
			currentDate.getMonth() + 1,
			0
		);
		return (
			<>
				<Grid
					container
					size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
					sx={{
						background: "#fff",
						border: "1px solid #e5e7eb",
						borderBottom: 0,
						borderRadius: "2px 2px 0 0",
						padding: "31px 20px 1rem 20px",
						marginBottom: "0px!important",
					}} columnSpacing={2}>
					<Grid
						size={{ xs: 12, sm: 12, md: 2.4, lg: 2.4, xl: 2.4 }}

						sx={{
							color: "rgba(0, 0, 0, 0.6)", fontSize: "0.875rem",
							"& .MuiGrid-root": {
							},
						}}>
						<EnhancedDropDownRHFWithLabel
							selectName={"employee"}
							items={employeeDDLListItems ?? []}
							selectedItem={"all"}
							label={"Employee"}
							testId={"employee-ddl"}
						// onSelectionChangeHandler={onEmployeeSelectionChangeHandler}
						/>


						<EnhancedButtonPrimeReact
							label="Apply Filter"
							raised
							type="submit"
							severity={EnhancedButtonPrimeReactSeverity.Secondary}
						// onClickHandler={() => setStateRunGetListAPICall(true)}
						/>

					</Grid>
					<Grid size={{ xs: 12, sm: 12, md: 2.4, lg: 2.4, xl: 2.4 }}>
						<EnhancedDropDownRHFWithLabel
							selectName={"payPeriod"}
							items={payPeriodListItems ?? []}
							selectedItem={"all"}
							label={"Pay Period"}
							testId={"pay-period-ddl"}
						// onSelectionChangeHandler={onPayPeriodSelectionChnageHandler}
						/>
					</Grid>
					<Grid size={{ xs: 12, sm: 12, md: 2.4, lg: 2.4, xl: 2.4 }}>
						<EnhancedDropDownRHFWithLabel
							selectName={"hourType"}
							items={[
								{
									label: "All",
									value: "all"
								},
								{
									label: "Regular Hrs",
									value: 100
								},
								{
									label: "Holiday Hrs",
									value: 400
								},
								{
									label: "Overtime 1.5",
									value: 200
								},
								{
									label: "Overtime 2.0",
									value: 300
								},
							]}
							label={"HourType"}
							testId={"hour-type"}
							selectedItem={"all"}
						// onSelectionChangeHandler={onHourTypeOnSelectionChnageHandler}/
						/>
					</Grid>
					<Grid
						size={{ xs: 12, sm: 12, md: 2.4, lg: 2.4, xl: 2.4 }}
						sx={{
							"& .MuiBox-root": {
								padding: "0pxImportant",
							},
							"& .calenderWrapper ": {
								marginTop: "-8px!important",
								marginBottom: "!important",
								minWidth: "178px!important"
								// fontSize: ".875rem" 
							}
						}}>
						<RHookFormDatePicker
							name="startDate"
							testId="start-date"
							label="Date Range"

							format="M dd, yy"
							defaultValue={firstDayOfCurrentMonth}
						// onDateSelectionChangeHandler={onSatrtDateSelectionChnageHandler}
						/>
					</Grid>
					<Grid
						size={{ xs: 12, sm: 12, md: 2.4, lg: 2.4, xl: 2.4 }}
						sx={{
							"& .MuiBox-root": {
								padding: "0pxImportant",
							},
							"& .calenderWrapper ": {
								marginTop: "15px!important",
								marginBottom: "0!important",
								minWidth: "178px!important"
								// fontSize: ".875rem" 
							}
						}}>
						<RHookFormDatePicker
							name="endDate"
							testId="end-date"
							label=""
							format="M dd, yy"
							defaultValue={lastDayOfCurrentMonth}
						// onDateSelectionChangeHandler={onEndDateSelectionChnageHandler}
						/>

					</Grid>
					{/* <Grid
						size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}
						sx={{ color: "rgba(0, 0, 0, 0.6)", fontSize: "0.875rem", }}>
						<EnhancedDropDownRHFWithLabel
							selectName={"classes"}
							// items={classesDDLList ?? []}
							items={[
								{
									label: "All",
									value: "all"
								},
								{
									label: "Regular Hrs",
									value: 100
								},
							]}
							selectedItem={"all"}
							label={"Classes"}
							testId={"classes-ddl"}
						// onSelectionChangeHandler={onClassesSelectionChnageHandler}
						/>
					</Grid> */}
				</Grid >
			</>
		);
	};
